import React, { useContext, useEffect, useState } from 'react';
import {
  AddBtn,
  BodyHeader,
  BookCover,
  BookGeneralInfo,
  BookMainInfo,
  BookPage,
  GrayLine,
  HeaderLogo,
  UploadBody,
  UploadHeader
} from './styles/bookUpload';
import axios from 'axios';
import SelectInput from './SelectInput.js';
import ChapterTopic from './chapterTopic';
import { BookUploadContext } from './context';
import {
  handlePostBook,
  handlePostChapter,
  handlePostSkill,
  handlePostTopic,
  handleReadBook,
  handlePostPageChapter
} from './apiSender';
import {
  API_HOST,
  __AWS_ACCESS_KEY__,
  __AWS_REGION__,
  __S3_BUCKET__,
  __SECRET_ACCESS_KEY__
} from '../../consts';
import { get } from 'lodash';
import AWS from 'aws-sdk';
import { toast } from 'react-toastify';
import {
  Modal,
  ModalBody,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink
} from 'reactstrap';
import classnames from 'classnames';
import BookUpload from './bookupload';

const ChapterUpload = () => {
  const [areaConhecimento, setAreaConhecimento] = useState([]);
  const [topicInfo, setTopicInfo] = useState([]);
  const [etapa, setEtapa] = useState([]);
  const [selectedFile, setSelectedFile] = useState('');
  const [file, setFile] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [areaConhecimentoLivro, setAreaConhecimentoLivro] = useState('');
  const [etapaLivro, setEtapaLivro] = useState('');
  const [livros, setLivros] = useState([]);
  const [livro, setLivro] = useState(null);
  const [activeTab, setActiveTab] = useState('chapter');

  const { data, setData, generalInfo } = useContext(BookUploadContext);

  useEffect(() => {
    const fetchAreasConhecimento = () => {
      axios.get(`${API_HOST}/core/area_conhecimento`).then((response) => {
        const area_conhecimento = response.data.map((item) => ({
          value: item.id,
          label: item.descricao
        }));
        setAreaConhecimento(area_conhecimento);
      });
    };
    const fetchEtapa = () => {
      axios.get(`${API_HOST}/core/periodo`).then((response) => {
        const options = [];
        response.data.map((mapResponse) => {
          if (mapResponse.etapa_nr) {
            options.push({
              value: mapResponse.id,
              label: mapResponse.descricao,
              codigo: mapResponse.etapa_nr
            });
          }
        });
        setEtapa(options);
      });
    };

    fetchAreasConhecimento();
    fetchEtapa();
  }, []);

  const handleSelectedLivro = (etapa_id) => {
    if (etapa_id && areaConhecimentoLivro) {
      axios
        .get(
          `${API_HOST}/openai/livro?area_conhecimento_id=${areaConhecimentoLivro}&etapa_id=${etapa_id}`
        )
        .then((response) => {
          const livros = response.data.map((item) => ({
            value: item.id,
            label: item.titulo
          }));
          setLivros(livros);
        });
    }
  };

  const handleFileChange = async (event) => {
    const S3_BUCKET = __S3_BUCKET__;
    const REGION = __AWS_REGION__;
    AWS.config.update({
      accessKeyId: __AWS_ACCESS_KEY__,
      secretAccessKey: __SECRET_ACCESS_KEY__
    });
    const myBucket = new AWS.S3({
      params: { Bucket: S3_BUCKET },
      region: REGION
    });
    let fileName = get(event.target.files[0], 'name');
    setSelectedFile(event.target.files[0]);
    const parts = fileName.split('.');
    const fileExtension = parts.pop();
    if (fileExtension !== 'pdf') {
      toast.error(
        'Selecione um arquivo em formato PDF para prosseguir com a ação.'
      );
      return;
    }
    setIsLoading(true);

    let key = fileName
      .replace(fileExtension, '')
      .replaceAll('.', '')
      .replaceAll('_', '')
      .replaceAll(' ', '')
      .replaceAll('-', '');
    const params = {
      ACL: 'public-read',
      Body: event.target.files[0],
      Bucket: S3_BUCKET,
      Key: key
    };
    myBucket
      .putObject(params)
      .on('httpUploadProgress', (evt) => {})
      .send(async (err, data) => {
        if (!err) {
          const bookInfo = await handleReadBook({ key });
          const newData = [];
          const bookProm =
            bookInfo &&
            bookInfo.chapters.map(async (chapter, index) => {
              // TRANSFORMA CODIGO DE HABILIDADE PARA ID!!!!!
              // bookInfo.chapters.map(async (chapter, index) => {
              const chapterTopics = [];
              const chapterSkills = [];
              const skillsId = [];
              if (chapter.skills) {
                // TRANSFORMA CODIGO DE HABILIDADE PARA ID!!!!!
                const requests = await chapter.skills.map(async (skill) => {
                  await axios
                    .get(
                      `${API_HOST}/matriz_referencia/habilidade/book_habilidade?area_conhecimento_id=${areaConhecimentoLivro}&etapa_id=${etapaLivro}&search=${skill}`
                    )
                    .then((response) => {
                      if (response.data) {
                        const nInfo = {
                          ...response.data[0],
                          value: response.data[0].id,
                          label: response.data[0].cd_habilidade
                        };
                        chapterSkills.push(nInfo);
                      }
                    });
                });
                await Promise.all(requests);
                chapterSkills.map((cptSkill) => skillsId.push(cptSkill.id));
              }
              const chapterInfo = {
                nome: chapter.title,
                topics: chapterTopics,
                capitulo: index + 1,
                skills: chapterSkills,
                capitulo_conteudo: chapter.chapter_content,
                chapter_pages_content: chapter.chapter_pages_content,
                capitulo_arquivo: `${key}.pdf`,
                id_livro: livro,
                ano: etapa.filter(({ value }) => etapaLivro.includes(value))[0]
                  .codigo
              };
              newData.push(chapterInfo);
            });
          await Promise.all(bookProm); // TRANSFORMA CODIGO DE HABILIDADE PARA ID!!!!!
          await setData(newData);
          await uploadFile(newData);
          setIsLoading(false);
        } // ENVIO PARA API
      });
    const reader = new FileReader();

    reader.onloadend = () => {};
  };

  const handleNewChapter = () => {
    const newChapter = {
      id: data.length,
      chapter_title: '',
      content: 0,
      first_page: 0,
      last_page: 0,
      skills: [],
      topic: []
    };
    setData([...data, newChapter]);
  };

  const newChapter = (cpt, id) => {
    return (
      <ChapterTopic
        setTopicInfo={setTopicInfo}
        topicInfo={topicInfo}
        chapterId={`${id}`}
        chapterInfo={cpt}
      />
    );
  };

  const uploadFile = async (newData = undefined) => {
    const bookPayload = { ...generalInfo, file: file };
    if (newData) {
      newData.map(async (chapter) => {
        const chapterPayload = {
          ...chapter,
          id_livro: livro,
          descricao: chapter.nome
        };
        const chapterResponse = await handlePostChapter(chapterPayload);
        if (chapterResponse && chapter.skills) {
          chapter.skills.map(async (skill) => {
            await handlePostSkill({
              id_capitulo: chapterResponse.id,
              id_habilidade: skill.id
            });
          });
        }
        if (chapterResponse && chapter.topics) {
          chapter.topics.map(async (topic) => {
            const topicPayload = { ...topic, descricao: topic.ds_topico };
            await handlePostTopic(topicPayload);
          });
        }
        if (chapterResponse && chapter.chapter_pages_content) {
          chapter.chapter_pages_content.map(async (page) => {
            const ChapterPagesPayload = {
              pagina_conteudo: page.content,
              nr_pagina: page.page,
              id_capitulo: chapterResponse.id
            };
            await handlePostPageChapter(ChapterPagesPayload);
          });
        }
      });
    } else {
      data.map(async (chapter) => {
        const chapterPayload = {
          ...chapter,
          id_livro: livro,
          descricao: chapter.nome
        };
        const chapterResponse = await handlePostChapter(chapterPayload);
        if (chapterResponse && chapter.skills) {
          chapter.skills.map(async (skill) => {
            await handlePostSkill({
              id_capitulo: chapterResponse.id,
              id_habilidade: skill.id
            });
          });
        }
        if (chapterResponse && chapter.topics) {
          chapter.topics.map(async (topic) => {
            const topicPayload = { ...topic, descricao: topic.ds_topico };
            await handlePostTopic(topicPayload);
          });
        }
        if (chapterResponse && chapter.chapter_pages_content) {
          chapter.chapter_pages_content.map(async (page) => {
            const ChapterPagesPayload = {
              pagina_conteudo: page.content,
              nr_pagina: page.page,
              id_capitulo: chapterResponse.id
            };
            await handlePostPageChapter(ChapterPagesPayload);
          });
        }
      });
    }
  };

  const modalUploadChapter = () => {
    return (
      <>
        <UploadBody>
          <BodyHeader>
            <span>Informações do livro</span>
            <div>Upload do capítulo</div>
          </BodyHeader>
          <BookGeneralInfo>
            <BookCover>
              {selectedFile ? (
                <>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      backgroundColor: '#84D955'
                    }}
                  >
                    <span
                      style={{
                        marginRight: '5px',
                        backgroundColor: '#F3C046',
                        padding: '5px',
                        cursor: 'pointer',
                        color: '#47BEF3',
                        borderRadius: '5px'
                      }}
                      onClick={() => setSelectedFile('')}
                    >
                      X
                    </span>
                    <span>Arquivo salvo para envio</span>
                  </div>
                </>
              ) : (
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fill: 'none'
                  }}
                >
                  <input
                    style={{
                      width: '215px'
                    }}
                    type="file"
                    onChange={handleFileChange}
                    disabled={!livro}
                  />
                </div>
              )}
            </BookCover>
          </BookGeneralInfo>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyItems: 'center',
              justifyContent: 'center'
            }}
          >
            <SelectInput
              placeholder="Selecione a área do conhecimento"
              width="411px"
              spanText="Área do conhecimento"
              options={areaConhecimento}
              value={areaConhecimentoLivro}
              field="area_conhecimento_id"
              onChange={(e) => setAreaConhecimentoLivro(e.target.value)}
            />
            <SelectInput
              placeholder="Selecione a série"
              // width="200px"
              spanText="Série/Ano"
              options={etapa}
              value={etapaLivro}
              field="etapa_id"
              onChange={(e) => {
                setEtapaLivro(e.target.value);
                if (e) {
                  handleSelectedLivro(e.target.value);
                }
              }}
            />
          </div>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyItems: 'center',
              justifyContent: 'space-around'
            }}
          >
            <SelectInput
              placeholder="Selecione o livro"
              width="671px"
              spanText="Livro"
              options={livros}
              value={livro}
              field="livro"
              onChange={(e) => setLivro(e.target.value)}
            />
          </div>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyItems: 'center',
              justifyContent: 'center',
              marginTop: '20px',
              gap: '25px'
            }}
          >
            <GrayLine />
          </div>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyItems: 'center',
              justifyContent: 'center',
              marginTop: '20px',
              gap: '15px',
              flexDirection: 'column'
            }}
          >
            <h1>Capítulo e tópicos do livro</h1>
            {data
              .sort((a, b) => a.capitulo - b.capitulo)
              .map((cpt, index) => newChapter(cpt, index))}
          </div>
          <AddBtn onClick={handleNewChapter}>
            <span>Adicionar novo capítulo</span>
          </AddBtn>
        </UploadBody>
      </>
    );
  };

  return (
    <BookPage>
      <Nav tabs>
        <NavItem>
          <NavLink
            className={classnames({
              active: activeTab === 'chapter'
            })}
            onClick={() => {
              setActiveTab('chapter');
            }}
          >
            Upload do capítulo
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={classnames({
              active: activeTab === 'book'
            })}
            onClick={() => {
              setActiveTab('book');
            }}
          >
            Upload de Livro
          </NavLink>
        </NavItem>
      </Nav>
      <UploadHeader>
        <span>Catalogação de livros</span>
        <HeaderLogo>
          <div style={{ backgroundColor: '#47BEF3' }}></div>
          <div style={{ backgroundColor: '#F3C046' }}></div>
          <div style={{ backgroundColor: '#84D955' }}></div>
        </HeaderLogo>
      </UploadHeader>

      <TabContent activeTab={activeTab}>
        <TabPane tabId="chapter">{modalUploadChapter()}</TabPane>
        <TabPane tabId="book">
          <BookUpload />
        </TabPane>
      </TabContent>
      <Modal
        style={{ marginTop: '500px' }}
        size="lg"
        isOpen={isLoading}
        // toggle={this.toggle}
      >
        <ModalBody style={{ padding: '1.5rem' }}>
          <div style={{ textAlign: 'center' }}>
            <img
              // src={get(this.props.theme, 'loadingGif')}
              style={{ width: '42px' }}
              alt=""
            />
            <p style={{ color: '#000' }}>Salvando livro</p>
            <p style={{ color: '#f00' }}>
              Mantenha está aba do navegador aberta durante o processo.
            </p>
          </div>
        </ModalBody>
      </Modal>
    </BookPage>
  );
};

export default ChapterUpload;
